import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateCarteira } from 'carteira/src/store/carteiraReducer';
import * as S from './carteiraAdminStyle';
import { useTranslation } from "react-i18next";
import { StatusRoute } from 'base/src/store/util/action/utilAction';
import PagedCarteiraUsuario from './components/pagedCarteiraUsuarios/pagedCarteiraUsuario';
import { ViewFull } from "base/src/components/Basic/View/view";
import { PageBanner } from "base/src/components/PageBanner/index";

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    teste: state.CarteiraAdminReducer.CarteiraPermissao,
  }),
  { StatusRoute }
);

export interface CarteiraAdminProps extends PropsFromRedux<typeof connector> {}

function CarteiraAdmin() {
  const { t } = useTranslation();
  //const container = new CarteiraAdminContainer(props);
  const take = 5;

  return (
    <S.Container>
      <PageBanner title={t('CarteiraAdmin')} subtile={t('GerencieCarteirasUsuarios')} />


          <ViewFull>
            <S.ContentContainer>
              <S.OptionTitle>{t('UsuariosCarteira')}</S.OptionTitle>
              <S.OptionSubTitle>{t('VisualizarGerenciarUsuarios')}</S.OptionSubTitle>
              <PagedCarteiraUsuario take={take} />
            </S.ContentContainer>
          </ViewFull>

     
    </S.Container>
  );
}

export default connector(CarteiraAdmin);
